import { useEffect, useRef } from 'react'
import './Hero.css'

const Hero = () => {
  const heroStageRef = useRef(null)

  useEffect(() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (reduceMotion) return undefined

    const handleScroll = () => {
      const scrolled = window.pageYOffset
      const heroStage = heroStageRef.current
      if (heroStage) {
        heroStage.style.transform = `translateY(${scrolled * 0.12}px)`
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const scrollToMenu = () => {
    const menu = document.querySelector('#menu')
    if (menu) {
      const headerHeight = document.querySelector('.header')?.getBoundingClientRect().height || 0
      const menuTop = menu.getBoundingClientRect().top + window.pageYOffset
      window.scrollTo({ top: menuTop - headerHeight - 12, behavior: 'smooth' })
    }
  }

  const openDelivery = () => {
    window.open('https://pedix.app/mister-burger/', '_blank', 'noopener,noreferrer')
  }

  return (
    <section className="hero" id="hero">
      <div className="hero-content">
        <div className="hero-copy">
          <span className="hero-kicker">Mota Botello 320</span>
          <h1>Mister Burger</h1>
          <p className="hero-lead">Calidad premium hecha en Catamarca.</p>
          <p className="hero-description">
            Hamburguesas en Catamarca, lomos, wraps y ensaladas con sabor de la casa,
            listas para delivery o pick up desde Mota Botello 320.
          </p>
          <div className="hero-actions">
            <button type="button" className="btn btn-primary hero-primary-action" onClick={openDelivery}>
              Hacer pedido
            </button>
            <button type="button" className="btn hero-secondary-action" onClick={scrollToMenu}>
              Ver menú
            </button>
          </div>
        </div>

        <div className="hero-stage" ref={heroStageRef}>
          <div className="hero-burst" aria-hidden="true"></div>
          <div className="hero-plate" aria-hidden="true"></div>
          <img src="/images/burgers/mota.png" alt="Mota de Mister" className="hero-product" />
        </div>
      </div>

      <div className="hero-marquee" aria-hidden="true">
        <span>
          Burgers · Lomos · Wraps · Ensaladas · Delivery · Pick up · Burgers · Lomos · Wraps · Ensaladas · Delivery · Pick up ·
        </span>
        <span>
          Burgers · Lomos · Wraps · Ensaladas · Delivery · Pick up · Burgers · Lomos · Wraps · Ensaladas · Delivery · Pick up ·
        </span>
      </div>
    </section>
  )
}

export default Hero
